import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

/**
 * Updates ONLY the timestamp of a force, preserving all other data.
 * This is used after a successful upload to update the local timestamp
 * without overwriting any changes the user may have made during the upload.
 */
export const updateForceTimestampReducer = (
    state: ForceState,
    { id, updatedAt }: ReturnType<typeof FORCE_ACTIONS.UPDATE_FORCE_TIMESTAMP>
) => {
    return {
        ...state,
        forces: state.forces.map((f) => {
            if (f.id !== id) {
                return f;
            }
            return { ...f, updatedAt };
        })
    };
};
